import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { Set } from 'immutable';
import { allLocationsId, asAvailabilityOptionFacet, asMediaFacet, availabilityOptionsWithLocation, availabilityOptionsWithoutLocation } from "../../../backendApi/CollectionApi";
import { isSmallViewport } from "../../../utils/browser";
import { Link } from "../../Link";
import { pushCollectionAction } from "../CollectionUtils";
import { AgeRangeFilter } from "./CollectionOverviewFilter/AgeRangeFilter";
import { AvailabilityFilter } from "./CollectionOverviewFilter/AvailabilityFilter";
import { GenreFilter } from "./CollectionOverviewFilter/GenreFilter";
import { LocationFilter } from "./CollectionOverviewFilter/LocationFilter";
import { MediumFilter } from "./CollectionOverviewFilter/MediumFilter";
export const emptyFilters = {
    genre: [],
    location: allLocationsId,
    medium: [],
    query: '',
    status: [
        'availableAnywhere',
        'onLoan'
    ],
    ageFrom: null,
    ageTo: null
};
export const defaultFilters = (selectedLocationId)=>selectedLocationId ? {
        ...emptyFilters,
        location: selectedLocationId || allLocationsId,
        status: [
            'availableHere',
            'availableElsewhere',
            'onLoan'
        ]
    } : emptyFilters;
export const templateFilterSettings = {
    ...emptyFilters,
    ageFrom: 0,
    ageTo: 100
};
const emptyFacets = {
    Genres: [],
    Locations: [],
    Media: [],
    Status: [],
    AgeRanges: []
};
export const Filter = (param)=>{
    let { filterSettings: { query, medium, genre, location, status, ageFrom, ageTo }, filterUpdaters: { updateMedium, updateGenre, updateLocation, updateStatus, updateAgeRange }, facets, filterExpanded, toggleFilterExpanded, config, className, preferredBranchId } = param;
    const smallViewport = isSmallViewport();
    const filterToggleText = filterExpanded ? 'Sluit filter' : 'Open filter';
    const push = pushCollectionAction();
    const activeMedia = Set(medium);
    const activeGenres = Set(genre);
    const activeStatus = Set(status);
    const hasLocation = location !== allLocationsId;
    const visibleOptions = hasLocation ? availabilityOptionsWithLocation : availabilityOptionsWithoutLocation;
    const { Genres, Locations, Media: mediaFacets, Status: statusFacets, AgeRanges } = facets !== 'unknown' ? facets : emptyFacets;
    const Media = mediaFacets.map(asMediaFacet);
    // The server returns option ids for the "current mode". Invalid ids (stale responses) are dropped.
    const Status = statusFacets.map(asAvailabilityOptionFacet).filter((f)=>f !== null);
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            smallViewport && /*#__PURE__*/ _jsxs("button", {
                className: "button button--primary c-filter__button",
                "aria-controls": "filter-content",
                "aria-expanded": filterExpanded,
                onClick: ()=>{
                    push(filterToggleText);
                    toggleFilterExpanded();
                },
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: filterExpanded ? 'expanded' : 'collapsed',
                        width: "2.4rem",
                        height: "2.4rem",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: filterExpanded ? '#icon--close' : '#icon--filter'
                        })
                    }),
                    filterToggleText
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                id: "filter-content",
                className: "c-filter",
                "aria-hidden": smallViewport ? !filterExpanded : null,
                children: [
                    /*#__PURE__*/ _jsx(LocationFilter, {
                        Locations,
                        activeLocation: location,
                        updateLocation,
                        preferredBranchId
                    }),
                    /*#__PURE__*/ _jsx(AvailabilityFilter, {
                        Status,
                        activeStatus,
                        updateStatus,
                        visibleOptions
                    }),
                    /*#__PURE__*/ _jsx(MediumFilter, {
                        Media,
                        activeMedia,
                        updateMedium
                    }),
                    /*#__PURE__*/ _jsx(GenreFilter, {
                        Genres,
                        activeGenres,
                        updateGenre
                    }),
                    /*#__PURE__*/ _jsx(AgeRangeFilter, {
                        AgeRanges,
                        ageFrom,
                        ageTo,
                        updateAgeRange
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "c-filter__content",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "c-filter__advanced c-external__link",
                            children: /*#__PURE__*/ _jsxs(Link, {
                                url: config.externalSearchUrl(query),
                                handle: ()=>push('Zoek in Wise', query),
                                children: [
                                    "Uitgebreid filteren",
                                    /*#__PURE__*/ _jsx("svg", {
                                        width: "2.4rem",
                                        height: "2.4rem",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ _jsx("use", {
                                            xlinkHref: "#icon--external"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
